import { AVAILABLE_OBJECTS } from "../data/loader";
import type { Manifest } from "../data/types";
import type { Mode } from "../domain/mode";
import { UI_THEMES, type UiThemeId } from "../theme/uiTheme";

interface Props {
  object: Manifest["object"];
  mode: Mode;
  onModeChange: (mode: Mode) => void;
  /** Dust mode needs a bright or intermediate epoch to redden. */
  reddeningAvailable: boolean;
  objectId: string;
  onObjectChange: (objectId: string) => void;
  uiTheme: UiThemeId;
  onUiThemeChange: (theme: UiThemeId) => void;
}

const MODE_BUTTONS: Array<{ mode: Mode; label: string; title?: string }> = [
  { mode: "observed", label: "Observed" },
  { mode: "interpolated", label: "Interpolated" },
  { mode: "reddening", label: "Dust model" },
  { mode: "all_epochs", label: "All epochs", title: "Listen to every epoch concurrently (Figure 1 view)" },
];

export function AppHeader(props: Props) {
  const { object, mode, onModeChange, reddeningAvailable, objectId, onObjectChange, uiTheme, onUiThemeChange } = props;
  return (
    <header className="header">
      <div>
        <h1>{object.shorthand} — A Changing-Look Quasar</h1>
        <div className="subtitle">
          {object.name} (z = {object.z})
        </div>
      </div>
      <div className="header-modes">
        {MODE_BUTTONS.map((b) => (
          <button
            key={b.mode}
            className={mode === b.mode ? "active" : ""}
            onClick={() => onModeChange(b.mode)}
            disabled={b.mode === "reddening" && !reddeningAvailable}
            title={
              b.mode === "reddening" && !reddeningAvailable
                ? "This object has no bright or intermediate epoch to redden"
                : b.title
            }
          >
            {b.label}
          </button>
        ))}
        <label className="theme-switcher">
          Object
          <select
            value={objectId}
            onChange={(e) => onObjectChange(e.target.value)}
            aria-label="Choose changing-look quasar"
          >
            {AVAILABLE_OBJECTS.map((obj) => (
              <option key={obj.id} value={obj.id}>
                {obj.label}
              </option>
            ))}
          </select>
        </label>
        <label className="theme-switcher">
          Theme
          <select
            value={uiTheme}
            onChange={(e) => onUiThemeChange(e.target.value as UiThemeId)}
            aria-label="Choose UI theme"
          >
            {UI_THEMES.map((theme) => (
              <option key={theme.id} value={theme.id}>
                {theme.label}
              </option>
            ))}
          </select>
        </label>
      </div>
    </header>
  );
}
